import {Routes} from '@angular/router';
import {FileExportsComponent} from './file-exports.component';
import {AuthGuardService as AuthGuard} from '../../auth-guard.service';
import {NgxPermissionsGuard} from 'ngx-permissions';
import {permissions} from '../../permissions';

export const routes: Routes = [
    {
        path: 'file-exports',
        component: FileExportsComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'File Exports',
            permissions: {
                only: [permissions.FILE_EXPORT_READ]
            }
        }
    }
];


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/file-exports/file-exports.routing.ts